import { Grid, Stack } from "@mui/material";
import classNames from "classnames/bind";
import React from "react";
import { Link } from "react-router-dom";
import styles from "./index.module.css";

function MemberCard2({ memberData }) {
  const cx = classNames.bind(styles);
  const handleGoToUrl = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <div className={cx("user-card")}>
      <Grid
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Link
          to={{ pathname: "/Profile_show", state: { id: memberData.id } }}
        >
          <img
            className={cx("user-avatar")}
            alt="avatar"
            src={memberData.img}
          />
        </Link>
        <span className={cx("user-name")}>
          {memberData.name}
        </span>
        <span className={cx("user-des")}>{memberData.motivation ? memberData.motivation : <br />}</span>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
        >
          <div
            className={cx("ig-btn")}
            style={{
              pointerEvents: !memberData.igLink && "none"
            }}
            onClick={() => handleGoToUrl(memberData.igLink)}
          />
          <div
            className={cx("linkin-btn")}
            style={{
              pointerEvents: !memberData.linkedInLink && "none"
            }}
            onClick={() => handleGoToUrl(memberData.linkedInLink)}
          />
          <div
            className={cx("fb-btn")}
            style={{
              pointerEvents: !memberData.fbLink && "none"
            }}
            onClick={() => handleGoToUrl(memberData.fbLink)}
          />
        </Stack>
      </Grid>
    </div>
  );
}
export default MemberCard2;
